import { render, staticRenderFns } from "./content-file.vue?vue&type=template&id=15e2c26c&scoped=true"
import script from "./content-file.vue?vue&type=script&lang=js"
export * from "./content-file.vue?vue&type=script&lang=js"
import style0 from "./content-file.vue?vue&type=style&index=0&id=15e2c26c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e2c26c",
  null
  
)

export default component.exports